// extracted by mini-css-extract-plugin
export var dataForm = "iphone-module--dataForm--1aaab";
export var klaviyoForm = "iphone-module--klaviyoForm--56bcc";
export var linkToIndex = "iphone-module--linkToIndex--1b8fd";
export var overlayImage = "iphone-module--overlayImage--bb4b5";